import { OptionDto } from "@/dtos";
import { VehicleStatus } from "@/helpers/types";

const statusVehicle = [
    { value: parseInt(VehicleStatus.OPERATING), label: 'OPERANDO' },
    { value: parseInt(VehicleStatus.MAINTENANCE), label: 'MANTENIMIENTO' },
    { value: parseInt(VehicleStatus.RETENTION), label: 'RETENIDO' },
    { value: parseInt(VehicleStatus.SUSPENDED), label: 'SUSPENDIDO' },
    { value: parseInt(VehicleStatus.RENOVATION), label: 'EN RENOVACIÓN' },
    { value: parseInt(VehicleStatus.RESERVE), label: 'RESERVA' },
    { value: parseInt(VehicleStatus.RETAIN), label: 'RETÉN' },
] as OptionDto[];

export const getStatusVehicleOptions = (): OptionDto[] => {
    return statusVehicle;
}

export const getVehicleStatus = (value: number): OptionDto => {
    return statusVehicle.find((x) => x.value == value) ?? statusVehicle[0];
}

export const getStatusVehicle = (value: number): VehicleStatus => {
    switch (value) {
        case 1001:
            return VehicleStatus.INACTIVE;
        case 1002:
            return VehicleStatus.VACATION;
        case 1003:
            return VehicleStatus.MAINTENANCE;
        case 1004:
            return VehicleStatus.SUSPENDED;
        case 1005:
            return VehicleStatus.OPERATING;
        case 1006:
            return VehicleStatus.RETENTION;
        case 1007:
            return VehicleStatus.RENOVATION;
        case 1008:
            return VehicleStatus.RESERVE;
        case 1009:
            return VehicleStatus.RETAIN;
        default:
            return VehicleStatus.OPERATING;
    }
}